import { render, staticRenderFns } from "./ActiveAssigneeChip.vue?vue&type=template&id=490a9383&scoped=true"
import script from "./ActiveAssigneeChip.vue?vue&type=script&lang=js"
export * from "./ActiveAssigneeChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490a9383",
  null
  
)

export default component.exports